import {
    CircularProgress,
    CircularProgressProps,
    circularProgressClasses,
} from "@mui/material";

type CustomCircularProgressProps = {
    circualcolor?: string;
} & CircularProgressProps;

export default function CustomCircularProgress(
    props?: CustomCircularProgressProps
) {
    const { ...othersx } = props;
    return (
        <CircularProgress
            variant="determinate"
            sx={{
                color: (theme) => props?.circualcolor ?? "",
                animationDuration: "550ms",
                // position: "absolute",
                // left: 0,
                [`& .${circularProgressClasses.circle}`]: {
                    strokeLinecap: "round",
                },
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "35px",
                alignSelf: "stretch",
                borderRadius: "24px",

                /* Ombre card */
                boxShadow: "0px 4px 30px 0px #E3E6E8",

                flexShrink: 0,
                "&.MuiCircularProgress-svg": {
                    strokeWidth:
                        "20px" /* Ajustez cette valeur pour définir l'épaisseur de la ligne */,
                    /* Autres styles personnalisés si nécessaires */
                },
                ...othersx,
            }}
            size={40}
            thickness={7}
            {...props}
        />
    );
}
